import React, { useEffect, useState } from "react";
import SideBar from "../Components/SideBar";
import NewTerminalForm from "../Components/terminalDashboard/NewTerminalForm";
import { useNavigate, useSearchParams } from "react-router-dom";
import { fetchTerminalsList, fetchTerminalsListForAdmin } from "../Services/terminal";
import { useTranslation } from "react-i18next";
import useZoomDisable from "../hook/useZoomDisable";
const TerminalDashboard = () => {
    const [searchParams] = useSearchParams();
    const canCreateNewTerminal = searchParams.get("create");
    const isLoading = false;
    const [terminals, setTerminals] = useState([]);
    const [showModal, setShowModal] = useState(false);
    const [selectedTerminal, setSelectedTerminal] = useState("");
    const navigate = useNavigate();

    const fetchAllTerminalListing = async () => {
        try {
            const res = canCreateNewTerminal === 'true' ? await fetchTerminalsList({ status: 'Pending,Approved' }) :  await fetchTerminalsListForAdmin({ status: 'Pending,Approved' });
            setTerminals(res?.data?.data);
        } catch (e) {
            console.error(e)
        }
    };
    useEffect(() => {
        fetchAllTerminalListing();
    }, []);
    const {t} = useTranslation();
    useZoomDisable();
    return <div className="bg-gray-800">
        <SideBar />
        {isLoading ? (
            <div className="flex h-screen justify-center items-center">
                
            </div>
        ) : <div className="bg-gray-800">
            <div className="flex h-screen justify-center items-center">
                <div className="max-w-3xl w-3xl bg-white rounded-lg shadow p-6">
                    <div className="flex justify-between items-center mb-6">
                        <h1 className="text-xl font-semibold text-gray-800">{t("terminals")}</h1>
                        {canCreateNewTerminal === 'true' && <button
                            onClick={() => setShowModal(true)}
                            className="px-4 py-2 border-2 border-blue-600 text-blue-600 rounded text-sm font-medium hover:bg-indigo-600 hover:text-white disabled:bg:grey-100"
                        >
                            {t("add_terminal")}
                        </button>}
                    </div>
                    <h1 className="text-md text-gray-800">{t("terminal_desc")}</h1>
                    {terminals.length === 0 && <span className="text-sm text-gray-500">{t("nofound_terminal")}</span>}
                    <ul className="divide-y divide-gray-200 h-[300px] overflow-auto">
                        {terminals.map((terminal, index) => (
                            <li key={index} className="py-3 flex items-center space-x-3">
                                <input
                                    type="radio"
                                    name="terminal"
                                    value={terminal.id}
                                    checked={selectedTerminal === terminal.id}
                                    onChange={() => setSelectedTerminal(terminal.id)}
                                    className="form-radio text-blue focus:ring-blue-600"
                                />
                                <span className="text-gray-700 font-medium">{terminal.name}</span>
                            </li>
                        ))}
                    </ul>
                    <button
                        disabled={!selectedTerminal}
                        onClick={() => { navigate(`/new-terminal-configs/${selectedTerminal}`, { state: { isAdmin:(canCreateNewTerminal=="true")?false:true } }); }}
                        className="px-4 mt-4 py-2 bg-blue-600 text-white rounded text-sm font-medium hover:bg-indigo-600 disabled:bg-gray-100 disabled:text-gray-400 disabled:font-black disabled:cursor-not-allowed"
                    >
                        {t("configure_terminal")}
                    </button>
                </div>

                <NewTerminalForm open={showModal} close={() => setShowModal(false)} submitRequest={fetchAllTerminalListing} />
            </div>
        </div>
        }</div>
};

export default TerminalDashboard;
